import React, { useEffect, useState } from 'react'
import Post from './Post'
import Footer from '../../../sub-components/Footer';
import CommonHeader from '../../../sub-components/CommonHeader';
import SliderHeader from '../../../sub-components/SliderHeader';
import ReactPaginate from "react-paginate";
import Pagination from '@mui/material/Pagination';
import { db } from '../../../firebase';


function FavRes({ uid }) {
  const [posts, setPosts] = useState([])
  const [pageNumber, setPageNumber] = useState(0);
  const [input, setInput] = useState("");
  const [posts1, setPosts1] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);

  
  useEffect(() => {
    db.collection('users').doc(uid).collection("FavouritesRestaurants").onSnapshot((snapshot) => {
      setPosts1(snapshot.docs.map((doc) => doc.data()))
    })

    if (posts1 !== undefined) {
      const finalPosts = posts1.filter(res => {
        return res.branchName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      })

      setFilteredPosts(finalPosts)
    }else {
      return <div>No results3</div>
    }
  }, [searchTerm])

  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value)
    // document.getElementsByClassName('dropdown-content3')[0].style.display = 'auto';
  }

   useEffect(() => {
    db.collection('users').doc(uid).collection("FavouritesRestaurants").onSnapshot(snapshot => {
           setPosts(snapshot.docs.map(doc => ({
               id: doc.id,
               post: doc.data(),
           })));
       })
   }, []);
   const menusPerPage = 6;
   const pagesVisited = pageNumber * menusPerPage;

   const displayMenus = <div>

        {/* <div><MenuCategory /></div> */}
       <section className="section pt-5 pb-5 products-listing">
         <div className="container">
           <div>
         {/* SideBar here */}
             <div className="">

                           <div className="row d-none-m">
             <div className="col-md-12">
               <div className="dropdown float-right">
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">All</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Newest</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Ratings</span> &nbsp;&nbsp;
                 </a>
               </div>
             </div>
           </div>
           <hr />
           <form className="explore-outlets-search mb-4 rounded overflow-hidden border">
       <div className="input-group">
         <input type="text" onChange={updateSearchResults} placeholder="Search for restaurants..." className="form-control border-0" />
         <div className="input-group-append">
           <button type="button" className="btn btn-primary">
             <i className="icofont-search" />
           </button>
         </div>
       </div>
     </form>
             <div className="product-list-view">
   
           <div className="row">
             {searchTerm === "" ?(
                  <>
                             {
             // hakuna > || iko < 
             posts.length > 0 ?(
               <>
               {
                              posts.slice(pagesVisited, pagesVisited + menusPerPage).map(({id, post}) => (
                                 <Post
                                 key={id} 
                                 branchImg={post.branchImg}
                                 branchName={post.branchName}
                                 restAddress={post.restAddress}
                                 status={post.status}
                                 closingTime={post.closingTime}
                                 openingTime={post.openingTime}
                                 resId={id}
                                 branchAddress={post.branchAddress}
                                 restaurant={post.restaurant}
                                 branchId={id}
                                 />
                               ))
               }
               </>
             ) : (<>  <center><i style={{fontSize:18,fontWeight:'bold'}}>No favourite yet!</i></center>
             </>)  
   } 
                  </>
             ):(
               <>
                            <div className="product-list-view">
   <div className="row">
            {
              filteredPosts.length > 0 ?(
                <>
                {
                                filteredPosts.map((posts2) => (

<Post 
                                branchImg={posts2.branchImg}
                                branchName={posts2.branch}
                                restAddress={posts2.restAddress}
                                status={posts2.status}
                                closingTime={posts2.closingTime}
                                openingTime={posts2.openingTime}
                                resId={posts2.restId}
                                branchAddress={posts2.branchAddress}
                                restaurant={posts2.restaurant}
                                branchId={posts2?.branchId}
/>
    ))
                                }
                </>
              ):(
                <><center style={{fontWeight:'bold'}}><h4>No results...</h4></center></>
              )

              
            
            }
          </div>
          </div>
               </>
             )}

     </div>
     </div>
   
              
   
             </div>
           </div>
         </div>
       </section>
   
   
   
   
   </div>

 const pageCount = Math.ceil(posts.length / menusPerPage);
 const changePage = ({ selected }) => {
   setPageNumber(selected);
 };


  return (
   <div>
     {displayMenus}
     <center>
       
     <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
     </center>

   </div>
  )
}

export default FavRes




